import {
	btn,
	Component,
	DateTime,
	E,
	tooltip,
	menu, Format, hr, ComponentEventMap, radio, Radiofield, DateInterval, h4
} from "@intermesh/goui";
import {CalendarItem} from "./CalendarItem.js";
import {CalendarAdapter} from "./CalendarAdapter.js";
import {client,Recurrence} from "@intermesh/groupoffice-core";
import {calendarStore, t} from "./Index.js";

export abstract class CalendarView<EventMap extends ComponentEventMap = ComponentEventMap> extends Component<EventMap> {

	/**
	 * This is set to the selected calendar ID but only if the user has writeAll permissions.
	 */
	static selectedCalendarId: string

	protected abstract updateItems(): void

	protected currentCreation?: CalendarItem
	protected day: DateTime = new DateTime()
	protected days: number = 1
	protected firstDay?: DateTime
	protected recur?: {[id:string]: Recurrence}
	protected contextMenu = menu({
			removeOnClose:false,
			isDropdown: true,
			listeners: {
				show:( {target}) => {

					target.findChild("delete")!.disabled = !this.current!.mayMove;
					target.findChild("edit")!.hidden = !this.current!.mayChange;

					const participationStatus = target.findChild("participationStatus") as Radiofield;
					const hr =  participationStatus.nextSibling()!
					participationStatus.hidden = hr.hidden = this.current!.isOwner ?? !this.current!.cal.myRights?.mayWriteAll;

					participationStatus.value = this.current?.calendarPrincipal?.participationStatus;
				}
			}
		},
		btn({itemId: "edit", icon:'edit', text: t('Edit','core','core'), handler: _ => this.current!.open()}),
		btn({itemId: "info", icon:'info', text: t('Info','core','core'), handler: _ => this.current!.info()}),
		hr(),

		radio({
			itemId: "participationStatus",
				type: "list",
				flex: 1,
				name: "participationStatus",
				options: [
					{icon:'check', text: t('Accept'), value: "accepted"},
					{icon:'question_mark', text: t('Maybe'), value: "tentative"},
					{icon:'remove_circle', text: t('Decline'), value: "declined"},
				],
				listeners: {
					change: ev => {
						ev.target.parent!.hide();
						this.current!.updateParticipation(ev.newValue, () => {
							ev.target.value = this.current?.calendarPrincipal?.participationStatus;
						});
					}
				}
			}
		),

		hr(),

		btn({itemId: "delete", icon:'delete', text: t('Delete','core'), handler: _ => this.current!.remove() }),
		btn({icon:'content_cut', text: t('Cut','core'), handler: _ => this.current!.cut() }),
		btn({icon:'content_copy', text: t('Copy','core'), handler: _ => this.current!.copy() }),
		hr(),

		btn({icon:'email', text: t('E-mail participants'), handler: _ => {
				if (this.current!.data.participants){
					go.showComposer({to: Object.values(this.current!.data.participants).map((p:any) => p.email)});
				}
			}
		}),
		//'-',

		btn({icon: 'import_export', text: t('Download ICS'), handler: _ => this.current!.downloadIcs() })
	);

	protected makeDraggableDay(el: HTMLElement, withoutTime = false) {
		let from : HTMLElement,
			till: HTMLElement,
			last: HTMLElement,
			anchor: HTMLElement,
			currentH = (new DateTime).format('H'),
			ev: CalendarItem,
			action: (day:HTMLElement) => void,
			hasMoved= false;

		const create = (day: HTMLElement) => {
				[from, till] = (anchor.compareDocumentPosition(day) & 0x02) ? [day,anchor] : [anchor,day];

				ev.data.showWithoutTime = from !== till || withoutTime || !client.user.calendarPreferences.defaultDuration;
				if(ev.data.showWithoutTime) {
					ev.start = new DateTime(from.dataset.date!+' 00:00:00.000');
					ev.end = new DateTime(till.dataset.date!+' 00:00:00.000').addDays(1);
				} else {
					const time = ' '+currentH+':00:00.000';
					ev.start = new DateTime(from.dataset.date!+time);
					ev.end = new DateTime(till.dataset.date!+time).add(new DateInterval(ev.data.duration));
				}
			},
			move = (day:HTMLElement) => {
				let [y,m,d] = day.dataset.date!.split('-').map(Number);
				ev.start.setYear(y).setMonth(m).setDate(d);
				ev.end = ev.start.clone().add(new DateInterval(ev.data.duration));
			},
			mouseMove = (e: MouseEvent & {target: HTMLElement}) => {

				const day = e.target.up('li[data-date]');
				if(day && day != last) {
					hasMoved = true;
					last = day;
					action(day)
					Object.values(ev.divs).forEach(d => d.remove());
					ev.divs = {};
					this.updateItems();
				}
			},
			mouseUp = (_e: MouseEvent) => {
				el.un('mousemove', mouseMove);
				(hasMoved || action === create) && ev.save( () => {
					this.currentCreation = undefined;
					this.populateViewModel();
				});
			};
		el.on('mousedown', (e) => {
			if(e.button !== 0) return;
			e.preventDefault(); // no text selection
			const event = e.target.up('div[data-key]');
			if(event) {
				ev = this.viewModel.find(m => m.key == event.dataset.key)!;
				if (ev && ev.mayChange) {
					action = move;
					el.on('mousemove', mouseMove);
					window.addEventListener('mouseup', mouseUp, {once: true});
				}
				return;
			}
			const day = e.target.up('li[data-date]');
			if(day) {
				const dd = client.user.calendarPreferences.defaultDuration,
					startStr = day.dataset.date! + ((withoutTime || !dd) ? ' 00:00:00.000' : (new DateTime).format(' H:00:00.000'));
				const data = {
						start: startStr,
						title: t('New event'),
						duration: withoutTime || !dd ? 'P1D' : dd,
						calendarId: CalendarView.selectedCalendarId,
						showWithoutTime: withoutTime || !dd
					},
					start = (new DateTime(data.start));

				this.currentCreation = ev = new CalendarItem({start, data, key: ''});
				this.viewModel.unshift(ev);
				this.updateItems();
				//this.drawEvent(ev, weekStart);
				//eventsContainer.prepend(ev.divs[0]);
				anchor = from = till = day;
				action = create;
				el.on('mousemove', mouseMove);
				window.addEventListener('mouseup', mouseUp, {once:true});
			}
		});
	}

	protected contextMenuEmpty = menu({removeOnClose:false, isDropdown: true, listeners: {
		beforeshow: ({target}) => {

			const btnOrig = target.items.find(item => item.itemId === 'paste-original-time')!;
			const btn = target.items.find(item => item.itemId === 'paste')!;

			if(!CalendarItem.clipboard) {
				btn.disabled = true;
				btn.text = t('Paste');

				btnOrig.hidden = true;
				return;
			}

			const dateHasTime = this.contextMenuEmpty.dataSet.date.length > 10;

			const withTime = dateHasTime || (!this.contextMenuEmpty.dataSet.viewSupportsTime && !CalendarItem.clipboard.data.showWithoutTime);

			const start = CalendarItem.pasteGetStart(this.contextMenuEmpty.dataSet.date),
				dateStr = withTime ? Format.dateTime(start) : Format.date(start);


			btn.disabled = false;
			btn.text = t("Paste '{title}' at {date}").replace('{date}', dateStr).replace('{title}', CalendarItem.clipboard.title)



			const origWithTime = dateHasTime || !CalendarItem.clipboard.data.showWithoutTime;


			const origStart = CalendarItem.pasteGetStart(this.contextMenuEmpty.dataSet.date.substring(0, 10)),
				origDateStr = origWithTime ? Format.dateTime(origStart) : Format.date(origStart);

			btnOrig.hidden = origDateStr === dateStr;
			btnOrig.text = t("Paste at original time ({time})").replace('{time}', Format.time(origStart)).replace('{title}', CalendarItem.clipboard.title)

		}}},
		btn({
			icon:'add',
			text: t('Appointment'),
			handler: _ => {
				const date = this.contextMenuEmpty.dataSet.date;
				let start, showWithoutTime = client.user.calendarPreferences?.defaultDuration == null;
				if (date.length > 10) {
					start = new DateTime(date);
					if(this.contextMenuEmpty.dataSet.viewSupportsTime) {
						showWithoutTime = false;
					}
				} else {
					const [y, m, d] = date.split('-').map(Number);
					start = new DateTime(); // time = now
					start.setYear(y).setMonth(m).setDate(d);
					if(this.contextMenuEmpty.dataSet.viewSupportsTime) {
						showWithoutTime = true;
					}
				}
				(new CalendarItem({key:'',data:{
					start:start.format('Y-m-d\TH:00:00.000'),
					title: t('New event'),
					showWithoutTime: showWithoutTime,
					duration: client.user.calendarPreferences?.defaultDuration ?? "P1D",
					calendarId: CalendarView.selectedCalendarId
				}})).save()
			}
		}),
		// btn({icon:'add', text: t('Reminder'), handler: _ => { console.warn('todo:reminder'); }}),
		hr(),

		btn({
			itemId:'paste',
			icon:'content_paste',
			text: t('Paste'),
			handler: _ => {
				CalendarItem.paste(CalendarView.selectedCalendarId, this.contextMenuEmpty.dataSet.date, this.contextMenuEmpty.dataSet.viewSupportsTime)
			}
		}),

		btn({
			itemId:'paste-original-time',
			icon:'content_paste',
			text: t('Paste at original time'),
			handler: _ => {
				CalendarItem.paste(CalendarView.selectedCalendarId, this.contextMenuEmpty.dataSet.date.substring(0, 10), false)
			}
		})
	);

	protected selected: CalendarItem[] = []
	public viewModel: CalendarItem[] = []

	protected adapter: CalendarAdapter

	constructor(adapter: CalendarAdapter) {
		super();
		CalendarView.selectedCalendarId = client.user.calendarPreferences?.defaultCalendarId; // default
		this.adapter = adapter;

		if(client.user.calendarPreferences.multiLine) {
			this.ROWHEIGHT = 3.8;
		}
	}

	update = (_data?: any) => {
		if(this.rendered) {
			//this.renderView();
			this.populateViewModel();
		}
	}

	private current?: CalendarItem

	private fmLocation(loc?: string) {
		if(!loc) return [];
		return [' @ ', /^https?:\/\//.test(loc) ? E('a', 'Web').attr('target','_blank').attr('href', loc) : loc];
	}

	protected eventHtml(item: CalendarItem, div?:HTMLElement, withIcons = true) {
		const e = item.data;
		if(!div) { // default
			const timeAndIcons = E('span',
				...item.categoryDots,
				...(withIcons ? item.icons : []));
			if(!e.showWithoutTime) {
				const time = E('span', Format.time(item.start));
				if(item.dayLength > 1) {
					time.append(' - ',Format.time(item.end));
				}
				timeAndIcons.append(time);
			}
			div = E('div',
				E('em', item.title || '('+t(item.data.privacy!='public' ? 'Private' :'Nameless')+')',
					...this.fmLocation(item.data.location)
				),

			)
			if(!e.showWithoutTime || item.icons.length || item.categoryDots.length) {
				div.prepend(timeAndIcons);
			}
		}
		if(item.key) {
			div.dataset.key = item.key;

		}

		if(client.user.calendarPreferences?.showTooltips)
			tooltip({
				style:{maxWidth:'60rem' ,wordBreak: 'break-word'},
				listeners: { 'render': ({target}) => {target.html = item.quickText}},
				target:div
			});


		return div.cls('allday',e.showWithoutTime)
			.cls('declined', item.isDeclined || item.isCancelled)
			.cls('undecided', item.needsAction)
			.cls('multiday', !e.showWithoutTime && item.dayLength > 1)
			.attr('tabIndex', 0)
			.on('click',(_ev)=> {
				this.selectItem(item);
			})
			//.on('mousedown', ev => ev.stopPropagation()) /* when enabled cant drag event in monthview */
			.on('contextmenu', ev => {

				this.selectItem(item);

				// todo: set id first
				if(!item.key || item.readOnly) return;
				this.current = item;
				this.contextMenu.showAt(ev);
				ev.preventDefault();
			}).on('dblclick', _ev => {
				if(!item.key) return;
				item.open();
			});
	}

	/**
	 * Merge items of the same event (uid and start) that are present in multiple selected calendars into one item.
	 * The calendars are collected in item.calendarIds so they can be shown with stackedCalendars()
	 */
	protected mergeDuplicates(allItems: Iterable<CalendarItem>) {
		const items = [...allItems], seen: {[key:string]: CalendarItem} = {}, result: CalendarItem[] = [];
		for(const item of items) {
			item.calendarIds = {};
			if(item.patched?.calendarId) item.calendarIds[item.patched.calendarId] = true;
		}
		for(const item of items) {
			const uid = item.data?.uid;
			if(!uid) {
				result.push(item);
				continue;
			}
			const key = uid + '|' + item.start.getTime() + '|' + item.end.getTime();
			const first = seen[key];
			if(first) {
				Object.assign(first.calendarIds, item.calendarIds);
			} else {
				seen[key] = item;
				result.push(item);
			}
		}
		return result;
	}

	protected clear() {
		this.viewModel.forEach(ev => {
			Object.values(ev.divs).forEach(d => d.remove());
		})
		this.viewModel = [];
	}

	protected slots!: any[];
	protected calcRow(start: number, days: number) {
		let row = 0,
			end = Math.min(start+days, this.slots.length);
		while(row < 40) {
			for(let i = start; i < end; i++) {
				if(this.slots[i][row]){ // used
					break; // next row
				}
				if(i == end-1) {
					// mark used
					for(let j = start; j < end; j++) {
						this.slots[j][row] = true;
					}
					return row;
				}
			}
			row++;
		}
		return 40;
	}

	protected ROWHEIGHT = 2.6

	/**
	 * Colored stripes, one for each calendar the (merged) item is in, joined together as one pill.
	 * Returns nothing when the item is in a single calendar and includeOwn is false.
	 *
	 * @param includeOwn also add a stripe for the calendar of the item itself
	 */
	protected calendarStripes(e: CalendarItem, includeOwn: boolean) {
		const stripes: HTMLElement[] = [];
		for(const key in e.calendarIds) {
			const own = key === e.data.calendarId;
			const color = own ? e.color : calendarStore.findById(key)?.color;
			if(color) {
				const stripe = E('i');
				stripe.style.color = '#' + color;
				own ? stripes.unshift(stripe) : stripes.push(stripe);
			}
		}
		if(!includeOwn && stripes.length < 2) {
			return [];
		}
		return [E('div', ...stripes).cls('stripes')];
	}

	protected stackedCalendars(e: CalendarItem) {
		let backgroundImage = 'linear-gradient(to right, ',
			padding = 0;

		for(const key in e.calendarIds) {
			if(key !== e.data.calendarId) {
				const cal = calendarStore.findById(key);
				if(cal) {
					backgroundImage += '#'+cal.color+' '+(padding/10)+'rem '+((padding+=6)/10)+'rem, ';
				}
			}
		}

		padding += 6;
		backgroundImage += 'currentColor '+((padding-6)/10)+'rem '+(padding/10)+'rem, transparent '+(padding/10)+'rem 100%)';
		return [backgroundImage, ((padding+6)/10)+'rem'];
	}

	// for full day view
	protected makestyle(e: CalendarItem, weekstart: DateTime, row?: number): Partial<CSSStyleDeclaration> {
		const dayDiff = weekstart.diff(e.start),
			days = dayDiff.getTotalDays()!,
			pos = dayDiff.invert ? 0 : days,
			dwidth = e.dayLength - (dayDiff.invert ? days : 0);

		row = row ?? this.calcRow(pos,dwidth);

		const width = Math.min(21, dwidth) * (100 / this.slots.length),
			left = pos * (100 / this.slots.length),
			top = row * this.ROWHEIGHT;
		const style: Partial<CSSStyleDeclaration> = {
			width: (width-.2).toFixed(2)+'%',
			left : (left).toFixed(2)+'%',
			top: top.toFixed(2)+'rem',
			color: '#'+e.color
		};
		if(e.data.showWithoutTime && Object.keys(e.calendarIds).length > 1) {
			[style.backgroundImage, style.paddingLeft] = this.stackedCalendars(e);
		}
		return style;
	}

	protected drawEventLine(e: CalendarItem, weekstart: DateTime, withIcons = true) {
		if(!e.divs[weekstart.format('YW')]) {
			const div = this.eventHtml(e, undefined, withIcons);
			if(!e.data.showWithoutTime) {
				// replaces the ::before stripe of the event when it is in multiple calendars
				const stripes = this.calendarStripes(e, false);
				div.cls("merged", stripes.length > 0).prepend(...stripes);
			}
			e.divs[weekstart.format('YW')] = div;
		}
		return e.divs[weekstart.format('YW')]
			.css(this.makestyle(e, weekstart))
			//.attr('style',this.makestyle(e, weekstart))
			.cls('continues', weekstart.diff(e.start).getTotalDays()! < 0)
	}

	private selectItem (item:CalendarItem) {
		this.focus(); // for catching keydown event
		// if not holding ctrl or shift, deselect
		while(this.selected.length) {
			Object.values(this.selected.shift()!.divs).forEach(el => el.cls('-selected'));
		}
		Object.values(item.divs).forEach(d => d.cls('+selected'));
		this.selected.push(item);
	}


	abstract renderView(): void;

	abstract goto(date:DateTime, days:number): void

	protected abstract populateViewModel(): void
}